import * as React from "react";
import { createComponent } from "@lit-labs/react";
import * as AllComponents from "../../components/index.js";
import { registerBeaconComponents } from "../../components/register/index.js";

export const registerReactComponent = (prefix, beaconComponentClassName) => {
  registerBeaconComponents(prefix);
  const componentToScope = AllComponents[beaconComponentClassName];
  const scopedTagName = prefix + "-" + componentToScope.tagName;
  return createComponent(React, scopedTagName, componentToScope, {});
};
